const themeClasses = {
  light: {
    body: "bg-gray-50 text-gray-800",
    leftbar: "border-r-[1px] border-r-gray-300",
    chatbotWrapper: "bg-gray-200",
    messageBody: "bg-gray-100 text-black border-gray-300",
    accordionBody: "bg-gray-100",
    userBubble: "bg-green-600 text-whifvte",
    bottonWrap: "bg-gray-300",
    bottonWrapInput: "bg-white text-black",
    leftNavLink: "text-black",
    leftbarTopBottom: "bg-white",
    modalContent: "bg-white",
    logo: "../images/logo-dark.png",
    relatedInfoBox: "bg-white border-gray-300",
    pricingModal: "bg-gray-100",
    plan: "border-gray-300",
    pricingText: "text-gray-900",
    pricingTitle: "text-gray-900",
    pricingBtn: "bg-gray-600 text-white hover:bg-gray-500",
    chatInputBox: "bg-white text-black",
    mbBottonWrap: "border-gray-300",
    botAnalyzing: "bg-white",
    botAnalyzingDots: "bg-gray-400 text-white",
    accordionBot: "border-gray-400",
    voiceBtn: "bg-white text-black border-l-[1px] border-l-gray-300",
    voiceIcon: "text-gray-700",
    voiceIconInactive: "text-gray-400",
    voiceIconListening: "text-red-500",
    modalOverlay: "bg-black bg-opacity-50",
    modalBox: "bg-white text-black border-gray-300",
    modalInput: "text-black border-gray-300",
    modalCloseIcon: "text-black",
    modalCloseIconLight: "text-gray-600 hover:text-gray-800",
    chatIconColor: "text-[#101b45]",
    btnSubmit: "bg-gray-700 text-white border-gray-100",
  },
  dark: {
    body: "bg-gray-900 text-gray-100",
    leftbar: "border-r-[1px] border-r-gray-600",
    chatbotWrapper: "bg-[#19191a]",
    messageBody: "bg-gray-900 text-white border-gray-600",
    accordionBody: "bg-[#2a2a2a]",
    userBubble: "bg-green-600 text-white",
    bottonWrap: "bg-[#000610]",
    bottonWrapInput: "bg-[#000610] text-white",
    leftNavLink: "text-white",
    leftbarTopBottom: "bg-[#000610]",
    modalContent: "bg-[#43454a]",
    logo: "../images/logo-light.png",
    relatedInfoBox: "bg-gray-900 border-gray-600",
    pricingModal: "bg-gray-900",
    plan: "border-gray-600",
    pricingText: "text-white",
    pricingTitle: "text-white",
    pricingBtn: "bg-white text-black hover:bg-gray-200",
    chatInputBox: "bg-gray-900 text-white",
    mbBottonWrap: "border-gray-600",
    botAnalyzing: "bg-gray-900 border-gray-600",
    botAnalyzingDots: "bg-white",
    accordionBot: "border-gray-600",
    voiceBtn: "bg-gray-900 text-black border-l-[1px] border-l-gray-600",
    voiceIcon: "text-gray-200",
    voiceIconInactive: "text-gray-500",
    voiceIconListening: "text-red-400",
    modalOverlay: "bg-black bg-opacity-60",
    modalBox: "bg-gray-800 text-white border-gray-500",
    modalInput: "bg-gray-900 border-gray-600 text-white",
    modalCloseIcon: "text-white",
    modalCloseIconDark: "text-gray-300 hover:text-gray-200",
    chatIconColor: "text-gray-900",
    btnSubmit: "bg-gray-900 text-white border-gray-600",
  },
};

export default themeClasses;
